import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import IconLibrary from '../IconLibrary';

export default function PendingAcceptanceDialogBody({
  loading,
  locationsLoading,
  hasNoActiveLocations,
  formatMessage,
  onCancel,
  children,
}) {
  if (loading) {
    return (
      <DialogContent>
        <Box textAlign="center">
          <CircularProgress size="30px" />
          <Typography>Processing</Typography>
        </Box>
      </DialogContent>
    );
  }

  if (locationsLoading) {
    return (
      <DialogContent>
        <Box textAlign="center">
          <CircularProgress size="30px" />
          <Typography>
            {formatMessage({
              id: 'LOADING',
              defaultMessage: 'Loading',
            })}
          </Typography>
        </Box>
      </DialogContent>
    );
  }

  return (
    <>
      {hasNoActiveLocations && (
        <DialogContent>
          <Typography color="error">
            {formatMessage({
              id: 'ACCEPT_JOB_NO_ACTIVE_LOCATIONS',
              defaultMessage:
                'At least one active location is required to accept a job. Please update your profile to add or activate a location.',
            })}
          </Typography>
        </DialogContent>
      )}
      {!hasNoActiveLocations && children}
      {hasNoActiveLocations && (
        <DialogActions display="flex" sx={{ justifyContent: 'center', my: 2 }}>
          <Button
            variant="contained"
            color="secondary"
            startIcon={<IconLibrary.Cancel />}
            onClick={onCancel}>
            {formatMessage({ id: 'CANCEL', defaultMessage: 'Cancel' })}
          </Button>
        </DialogActions>
      )}
    </>
  );
}
